// extracted by mini-css-extract-plugin
export default {"wrapper":"IntegrationsList_wrapper__L-pmf","description":"IntegrationsList_description__z3-qK","list":"IntegrationsList_list__i-28C","coming":"IntegrationsList_coming__Im2qw"};